// opervex-frontend/src/pages/HumanResources/Employee.js

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, InputGroup, Card, Button } from "react-bootstrap";
import { FaSearch, FaPlus, FaSave, FaPencilAlt } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import MaskedFormControl from "react-bootstrap-maskedinput";

import { useAuth } from "../../contexts/AuthContext";
import { SearchHelpModal } from "../../utils/SearchHelp";
import useOpervex from "../../hooks/useOpervex";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";

const rolePageRequire = "EMPLOYEE";

const dataDefault = {
  id: "",
  firstName: "",
  lastName: "",
  cpf: "",
  groupType: "",
  email: "",
  corporateEmail: "",
  phone: "",
  team: null,
  sector: null,
  role: null,
  seller: false,
  externalCode: "",
  registrationCode: "",
  dateStart: null,
  dateEnd: null,
  seniorManager: null,
  seniorManagerName: "",
  disabled: false,
};

const actionsDefault = {
  create: true,
  change: true,
  delete: true,
  save: true,
};

const Employee = () => {
  const { roles, loadingGlobal } = useAuth();
  const [disabledField, setDisabledField] = useState(true);
  const [disabledCPF, setDisabledCPF] = useState(true);
  const [actions, setActions] = useState(actionsDefault);
  const [data, setData] = useState(dataDefault);
  const [rolesEmployee, setRolesEmployee] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [teams, setTeams] = useState([]);
  const { id } = useParams();
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const fetchData = async () => {
      commandAction({ ...actionsDefault, create: false });

      setSectors(await OpervexAPI.HumanResources.Sectors.findAll());
      setTeams(await OpervexAPI.HumanResources.Teams.findAll());
      setRolesEmployee(await OpervexAPI.HumanResources.Roles.findAll());

      if (id) await searchAPI(id);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) {
    return <div>Carregando...</div>;
  }

  // Commands Actions
  const commandAction = (actions) => {
    const hasPermission = roles.find((role) => role.command === rolePageRequire);

    if (!hasPermission) {
      setActions(actionsDefault);
      return;
    }

    if (!actions.create) actions.create = !hasPermission.actions.some((action) => action.key === "Create");
    if (!actions.change) actions.change = !hasPermission.actions.some((action) => action.key === "Change");

    setActions({ ...actions });
  };

  //Handlers Buttons
  // Create
  const handleButtonCreate = () => {
    setData(dataDefault);
    commandAction({ ...actionsDefault, save: false });
    setDisabledField(false);
    setDisabledCPF(false);
  };

  // Change
  const handleButtonChange = async () => {
    commandAction({ ...actionsDefault, save: false });
    setDisabledField(false);
    setDisabledCPF(true);
  };

  // Cancel
  const handleButtonCancel = () => {
    if (data.id === "") {
      setData(dataDefault);
      setDisabledField(true);
      setDisabledCPF(true);
      commandAction({ ...actionsDefault, create: false });
    } else {
      searchAPI(data.id);
    }
  };

  // Search
  const handleButtonSearch = async () => {
    const item = await SearchHelpModal({
      urlData: "/HumanResources/Employees/SearchHelp",
      schema: await OpervexAPI.HumanResources.Employees.schema(),
    });

    if (item && item.id) await searchAPI(item.id);
  };

  const handleButtonSearchManager = async () => {
    if (disabledField) return;

    const item = await SearchHelpModal({
      urlData: "/HumanResources/Employees/SearchHelp",
      schema: await OpervexAPI.HumanResources.Employees.schema(),
    });

    if (!item.id) return;

    var newData = { ...data };

    const result = await OpervexAPI.HumanResources.Employees.findId(item.id);

    if (result && !result.error) {
      newData.seniorManager = item.id;
      newData.seniorManagerName = result?.firstName + " " + result?.lastName;
    } else {
      newData.seniorManager = "";
      newData.seniorManagerName = "";
    }

    setData(newData);
  };

  // Save
  const handleButtonSave = async () => {
    const body = { ...data };

    if (body.corporateEmail === "") body.corporateEmail = null;
    if (body.registrationCode === "") body.registrationCode = null;
    if (body.externalCode === "") body.externalCode = null;

    body.cpf = body.cpf.replaceAll(".", "").replaceAll("-", "");

    if (data.id) {
      const result = await OpervexAPI.HumanResources.Employees.update(body.id, body);
      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(data.id);

      alert("Atualizado com sucesso!");
    } else {
      const result = await OpervexAPI.HumanResources.Employees.create(body);
      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }
      await searchAPI(result.id);

      alert("Criado com sucesso!");
    }
  };

  // Search By Id
  const searchAPI = async (id) => {
    setDisabledField(true);
    setDisabledCPF(true);

    if (!id) return;

    var result = await OpervexAPI.HumanResources.Employees.findId(id);

    if (result) {
      if (result.seniorManager) {
        const manager = await OpervexAPI.HumanResources.Employees.findId(result.seniorManager);

        if (manager.error) result.seniorManagerName = "";
        else result.seniorManagerName = manager?.firstName + " " + manager?.lastName;
      } else result.seniorManagerName = "";

      setData(result);

      commandAction({ ...actionsDefault, create: false, change: false });
    } else {
      setData(dataDefault);
      commandAction({ ...actionsDefault, create: false });
      alert("Produto não encontrado!");
    }
  };

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;

    var _value = value;
    var newData = { ...data };

    switch (name) {
      case "team":
      case "sector":
      case "role":
        _value = Number(_value);
        if (_value === 0) _value = null;
        break;
      case "seniorManager":
        _value = Number(_value);

        const manager = await OpervexAPI.HumanResources.Employees.findId(_value);

        if (manager.error) newData.seniorManagerName = "";
        else newData.seniorManagerName = manager?.firstName + " " + manager?.lastName;

        break;
      default:
        break;
    }

    newData = {
      ...newData,
      [name]: type === "checkbox" ? checked : _value,
    };

    setData(newData);
  };

  return (
    <>
      <Container className="mt-2">
        <Form>
          {/* ----- Header -----*/}
          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Cabeçalho</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="success" size="sm" className="me-2" onClick={handleButtonCreate} hidden={actions.create}>
                    <FaPlus /> Novo
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonChange} hidden={actions.change}>
                    <FaPencilAlt /> Alterar
                  </Button>
                  <Button variant="danger" size="sm" className="me-2" onClick={handleButtonCancel} hidden={actions.save}>
                    <MdOutlineCancel /> Cancelar
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonSave} hidden={actions.save}>
                    <FaSave /> Salvar
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Código</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" size="sm" value={data.id} name="id" onChange={handleChange} disabled={true} />

                      <InputGroup.Text size="sm" type="button" onClick={handleButtonSearch}>
                        <FaSearch />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="firstName"
                      value={data.firstName}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Sobrenome</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="lastName"
                      value={data.lastName}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>

                <Col md={2} className="d-flex align-items-center">
                  <Form.Group>
                    <Form.Label></Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="disabled"
                      checked={data.disabled}
                      name="disabled"
                      onChange={handleChange}
                      label="Inativo"
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {/* ----- Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Informações Pessoais</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Label>CPF</Form.Label>
                  <MaskedFormControl
                    type="text"
                    size="sm"
                    mask="111.111.111-11"
                    name="cpf"
                    value={data.cpf}
                    onChange={handleChange}
                    disabled={disabledCPF}
                  />
                </Col>

                <Col md={2}>
                  <Form.Label>Telefone</Form.Label>
                  <MaskedFormControl
                    type="text"
                    size="sm"
                    mask="(11) 11111-1111"
                    name="phone"
                    value={data.phone}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>E-mail</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}></Col>
              </Row>
            </Card.Body>
          </Card>
          {/* ----- Additional Data -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Informações Adicionais</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>E-mail Corpotativo</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="corporateEmail"
                      value={data.corporateEmail}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}></Col>
              </Row>
            </Card.Body>
          </Card>
          {/* ----- Organizational Data -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Dados Organizacionais</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Setor</Form.Label>
                    <Form.Select size="sm" value={data.sector} onChange={handleChange} name="sector" disabled={disabledField}>
                      <option value="">Selecione...</option>
                      {sectors?.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Equipe</Form.Label>
                    <Form.Select size="sm" value={data.team} onChange={handleChange} name="team" disabled={disabledField}>
                      <option value="">Selecione...</option>
                      {teams?.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Código Externo</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="externalCode"
                      value={data.externalCode}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Admissão</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateStart"
                      size="sm"
                      value={data.dateStart || ""}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Grupo</Form.Label>
                    <Form.Select size="sm" value={data.groupType} onChange={handleChange} name="groupType" disabled={disabledField}>
                      <option value="">Selecione...</option>
                      <option key="C" value="C">
                        Contratato
                      </option>
                      <option key="T" value="T">
                        Terceirizado
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Cargo</Form.Label>
                    <Form.Select
                      size="sm"
                      value={data.role ? data.role : ""}
                      onChange={handleChange}
                      name="role"
                      disabled={disabledField}
                    >
                      <option value="">Selecione...</option>
                      {rolesEmployee?.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Matrícula</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="registrationCode"
                      value={data.registrationCode}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Demissão</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateEnd"
                      size="sm"
                      value={data.dateEnd || ""}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Código do Gestor</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        size="sm"
                        value={data.seniorManager ? data.seniorManager : ""}
                        name="seniorManager"
                        onChange={handleChange}
                        disabled={disabledField}
                      />

                      <InputGroup.Text size="sm" type="button" onClick={handleButtonSearchManager}>
                        <FaSearch />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Nome do Gestor</Form.Label>
                    <Form.Control type="text" size="sm" name="seniorManagerName" value={data.seniorManagerName} disabled={true} />
                  </Form.Group>
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  <Form.Group>
                    <Form.Label></Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="seller"
                      checked={data.seller}
                      name="seller"
                      onChange={handleChange}
                      label="Vendedor"
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
      </Container>
    </>
  );
};

export default Employee;
